import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';

import Compass from "./Compass";
import Gps from "./Gps";

import Barometer from './Barometer';
import Anemometer from './Anemometer';

class Wheelhouse extends React.Component {
  constructor() {
    super();

    this.state = {}
  }

  render() {
    const { barometer, anemometer, gps, compass } = this.props.wheelhouse;

    return (
      <div>
        <div className="text-center text-corporate"><small >Wheelhouse</small></div>
        <Row className="bg-lightgray border rounded p-2" >
          <Col sm={3} className="p-1"><Barometer data={barometer} /></Col>
          <Col sm={3} className="p-1"><Anemometer data={anemometer}/></Col>
          <Col sm={3} className="p-1"><Gps data={gps} /></Col>
          <Col sm={3} className="p-1"><Compass data={compass} /></Col>
        </Row>
      </div>

    );
  }
}

const mapStoreToProps = (store) => ({
  wheelhouse: store.wheelhouse
});

export default connect(mapStoreToProps)(Wheelhouse);
